import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: 10, //theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

const Snackbar = withStyles(styles)((props) => {
  // const classes = useStyles1();
  const { classes, className, message, onClose, variant, showClose = false, showIcon = true, textStyle, ...other } = props;
  const Icon = variantIcon[variant];

  const actions = [];

  if (showClose) {
    actions.push((
      <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
        <CloseIcon className={classes.icon} />
      </IconButton>
    ))
  }

  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          {showIcon && (
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
          )}
          <span style={textStyle}>
            {message}
          </span>          
        </span>
      }
      action={actions}
      {...other}
    />
  );
})

Snackbar.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
};

export default Snackbar;
